var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialog.visible,
            width: "40%",
            "append-to-body": "",
            "modal-append-to-body": false,
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
            closed: _vm.closed,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    disabled: _vm.dialog.disabled,
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "关联插件：", prop: "pluginId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择插件ID",
                            size: "small",
                            clearable: "",
                          },
                          on: { change: _vm.pluginChange },
                          model: {
                            value: _vm.form.pluginId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "pluginId", $$v)
                            },
                            expression: "form.pluginId",
                          },
                        },
                        _vm._l(_vm.pluginIdList, function (item) {
                          return _c("el-option", {
                            key: item.pluginId,
                            attrs: {
                              label: `[${item.pluginCode}]-${item.name}-${item.ver}`,
                              value: item.pluginId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "策略名称：", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入策略名称",
                          maxlength: "32",
                          size: "small",
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "加载方式：", prop: "loadType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.loadType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "loadType", $$v)
                            },
                            expression: "form.loadType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("手动"),
                          ]),
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("自动"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "优先级：", prop: "priority" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "number",
                          placeholder: "输入正整数，按数字从大到小进行命中",
                          size: "small",
                        },
                        model: {
                          value: _vm.form.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "priority", $$v)
                          },
                          expression: "form.priority",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "container" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "配置类型：", prop: "appType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.appType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "appType", $$v)
                                },
                                expression: "form.appType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("渠道"),
                              ]),
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("平台"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.form.appType === "1"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "配置渠道：",
                                prop: "channel.type",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.channel.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form.channel, "type", $$v)
                                    },
                                    expression: "form.channel.type",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: "0" } }, [
                                    _vm._v("全部渠道"),
                                  ]),
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v("指定渠道"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.appType === "1" && _vm.form.channel.type === "0"
                        ? _c(
                            "el-form-item",
                            {
                              key: "form.channel.channelInfoList[0].terminalType",
                              attrs: {
                                label: "终端类型：",
                                prop: "channel.channelInfoList[0].terminalType",
                              },
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    indeterminate:
                                      _vm.form.channel.channelInfoList[0]
                                        .terminalType.length === 1,
                                  },
                                  on: {
                                    change: (val) => {
                                      _vm.handleCheckAllChange(val, 1)
                                    },
                                  },
                                  model: {
                                    value: _vm.terminalTypeAll,
                                    callback: function ($$v) {
                                      _vm.terminalTypeAll = $$v
                                    },
                                    expression: "terminalTypeAll",
                                  },
                                },
                                [_vm._v("全选")]
                              ),
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value:
                                      _vm.form.channel.channelInfoList[0]
                                        .terminalType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.channel.channelInfoList[0],
                                        "terminalType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.channel.channelInfoList[0].terminalType",
                                  },
                                },
                                [
                                  _c("el-checkbox", { attrs: { label: "1" } }, [
                                    _vm._v("发送端"),
                                  ]),
                                  _c("el-checkbox", { attrs: { label: "2" } }, [
                                    _vm._v("接收端"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.appType === "1" && _vm.form.channel.type === "1"
                        ? _c(
                            "el-form-item",
                            {
                              key: "channel.channelInfoList[0].channelName",
                              attrs: {
                                label: "渠道(appID)：",
                                prop: "channel.channelInfoList[0].channelName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                on: {
                                  focus: function ($event) {
                                    return _vm.channelClick()
                                  },
                                },
                                model: {
                                  value:
                                    _vm.form.channel.channelInfoList[0]
                                      .channelName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.channel.channelInfoList[0],
                                      "channelName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.channel.channelInfoList[0].channelName",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.appType === "2"
                        ? _c(
                            "el-form-item",
                            {
                              key: "platform.customizedTypeList",
                              attrs: {
                                label: "定制类型：",
                                prop: "platform.customizedTypeList",
                              },
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    indeterminate:
                                      _vm.form.platform.customizedTypeList
                                        .length === 1,
                                  },
                                  on: {
                                    change: (val) => {
                                      _vm.handleCheckAllChange(val, 2)
                                    },
                                  },
                                  model: {
                                    value: _vm.customizedTypeListAll,
                                    callback: function ($$v) {
                                      _vm.customizedTypeListAll = $$v
                                    },
                                    expression: "customizedTypeListAll",
                                  },
                                },
                                [_vm._v("全选")]
                              ),
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.form.platform.customizedTypeList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.platform,
                                        "customizedTypeList",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.platform.customizedTypeList",
                                  },
                                },
                                [
                                  _c("el-checkbox", { attrs: { label: "1" } }, [
                                    _vm._v("SDK"),
                                  ]),
                                  _c("el-checkbox", { attrs: { label: "2" } }, [
                                    _vm._v("APP"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.appType === "2"
                        ? _c(
                            "el-form-item",
                            {
                              key: "platform.platformMap.1",
                              attrs: {
                                label: "发端类型：",
                                prop: "platform.platformMap.1",
                              },
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    indeterminate:
                                      Object.entries(
                                        _vm.form.platform.platformMap["1"]
                                      ).length > 0 &&
                                      Object.entries(
                                        _vm.form.platform.platformMap["1"]
                                      ).length < 6,
                                  },
                                  on: {
                                    change: (val) => {
                                      _vm.handleCheckAllChange(val, 3)
                                    },
                                  },
                                  model: {
                                    value: _vm.sendPlatformAll,
                                    callback: function ($$v) {
                                      _vm.sendPlatformAll = $$v
                                    },
                                    expression: "sendPlatformAll",
                                  },
                                },
                                [_vm._v("全选")]
                              ),
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.form.platform.platformMap["1"],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.platform.platformMap,
                                        "1",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.platform.platformMap['1']",
                                  },
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticClass: "tips",
                                      attrs: { label: "Android" },
                                    },
                                    [
                                      _vm._v("Android "),
                                      _c(
                                        "span",
                                        { staticClass: "tips-content" },
                                        [_vm._v("(二选一)")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: "IOS" } },
                                    [_vm._v("IOS")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: "Windows" } },
                                    [_vm._v("Windows")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: "MAC" } },
                                    [_vm._v("MAC")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: "web" } },
                                    [_vm._v("web")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: "weixin" } },
                                    [_vm._v("微信小程序")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.appType === "2"
                        ? _c(
                            "el-form-item",
                            {
                              key: "platform.platformMap.2",
                              attrs: {
                                label: "收端类型：",
                                prop: "platform.platformMap.2",
                              },
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    indeterminate:
                                      Object.entries(
                                        _vm.form.platform.platformMap["2"]
                                      ).length > 0 &&
                                      Object.entries(
                                        _vm.form.platform.platformMap["2"]
                                      ).length < 5,
                                  },
                                  on: {
                                    change: (val) => {
                                      _vm.handleCheckAllChange(val, 4)
                                    },
                                  },
                                  model: {
                                    value: _vm.receivePlatformAll,
                                    callback: function ($$v) {
                                      _vm.receivePlatformAll = $$v
                                    },
                                    expression: "receivePlatformAll",
                                  },
                                },
                                [_vm._v("全选")]
                              ),
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.form.platform.platformMap["2"],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.platform.platformMap,
                                        "2",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.platform.platformMap['2']",
                                  },
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticClass: "tips",
                                      attrs: { label: "Android" },
                                    },
                                    [
                                      _vm._v("Android（TV）"),
                                      _c(
                                        "span",
                                        { staticClass: "tips-content2" },
                                        [_vm._v("(二选一)")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: "Windows" } },
                                    [_vm._v("Windows")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: "MAC" } },
                                    [_vm._v("MAC")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: "Linux" } },
                                    [_vm._v("Linux")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: "cloudApp" } },
                                    [_vm._v("云应用")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.appType === "2"
                        ? _c("el-form-item", { attrs: { label: " " } }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "#a4a4a4",
                                },
                              },
                              [
                                _vm._v(
                                  "说明：前置条件之间为或的关系，例如只选择Android、iOS，则代表Android、iOS皆会命中，其中未选择的端不会命中"
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _c("br"),
                      _c(
                        "el-form-item",
                        { attrs: { label: "厂商：", prop: "manufacturer" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "厂商标识，例如：小米",
                              maxlength: "64",
                              size: "small",
                            },
                            model: {
                              value: _vm.form.manufacturer,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "manufacturer", $$v)
                              },
                              expression: "form.manufacturer",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌：", prop: "brand" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "品牌标识，例如：migu",
                              maxlength: "64",
                              size: "small",
                            },
                            model: {
                              value: _vm.form.brand,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "brand", $$v)
                              },
                              expression: "form.brand",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "型号：", prop: "model" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "型号标识，例如：小米盒子BOX",
                              maxlength: "64",
                              size: "small",
                            },
                            model: {
                              value: _vm.form.model,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "model", $$v)
                              },
                              expression: "form.model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "uid：", prop: "uid" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "设备UID",
                              maxlength: "64",
                              size: "small",
                            },
                            model: {
                              value: _vm.form.uid,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "uid", $$v)
                              },
                              expression: "form.uid",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "uuid：", prop: "uuid" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "用户uuid",
                              maxlength: "64",
                              size: "small",
                            },
                            model: {
                              value: _vm.form.uuid,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "uuid", $$v)
                              },
                              expression: "form.uuid",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { staticStyle: {}, attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.hide } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirm },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("channel-popups", {
        attrs: {
          "app-id": _vm.channelForm.channelId,
          visible: _vm.channelForm.showPopups,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.channelForm, "showPopups", $event)
          },
          comfirm: _vm.channelConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }